import { render, staticRenderFns } from "./login.vue?vue&type=template&id=5151ef3b&scoped=true&"
import script from "./login.vue?vue&type=script&lang=ts&"
export * from "./login.vue?vue&type=script&lang=ts&"
import style0 from "./login.vue?vue&type=style&index=0&id=5151ef3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151ef3b",
  null
  
)

component.options.__file = "login.vue"
export default component.exports